module.exports = __webpack_public_path__ + "assets/img/speculation.953a63f3.png";